module.exports = __webpack_public_path__ + "img/album18_52.8269b2aa.jpg";